import { headers, urlbase } from "../constants/Constants";
import axios from "axios";

export async function login(username: string, password: string) {
  try {
    const loginCreds = {
      id_num: username,
      password: password,
    };

    const url = urlbase().concat("student/login");

    const loginResponse = await axios.post(url, JSON.stringify(loginCreds), {
      headers: headers(),
    });
    return {
      code: loginResponse.status,
      message: loginResponse.statusText,
      data: loginResponse.data,
    };
  } catch (e) {
    return { code: e.status, message: e.response, data: e.response };
  }
}

export async function resendValidationLink(id: number, token: string) {
  try {
    const url = urlbase().concat("student/resendValidationLink");

    const body = {
      id: id,
      token: token,
    };

    const resendVerificationResponse = await axios.post(url, JSON.stringify(body), {
      headers: headers(),
    });

    return {
      code: resendVerificationResponse.status,
      message: resendVerificationResponse.statusText,
      data: resendVerificationResponse.data,
    };
  } catch (e) {
    return { code: e.status, message: e.response, data: e.response };
  }
}

export async function forgotPassword(
  id_num: string,
  password: string,
  confirmPassword: string,
  q1: string,
  a1: string,
  q2: string,
  a2: string
) {
  try {
    const forgotPasswordCreds = {
      id_num: id_num,
      password: password,
      confirmPassword: confirmPassword,
      q1: q1,
      a1: a1,
      q2: q2,
      a2: a2,
    };
    const url = urlbase().concat("student/password/v2");
    const loginResponse = await axios.post(
      url,
      JSON.stringify(forgotPasswordCreds),
      { headers: headers() }
    );
    return {
      code: loginResponse.status,
      message: loginResponse.statusText,
      data: loginResponse.data,
    };
  } catch (e) {
    return { code: e.status, message: e.response, data: e.response };
  }
}

export async function getSchools() {
  try {
    const url = urlbase().concat("search_schools");
    const schools = await axios.get(url, { headers: headers() });
    return {
      code: schools.status,
      message: schools.statusText,
      data: schools.data,
    };
  } catch (e) {
    return { code: e.status, message: e.response, data: e.response };
  }
}

export async function getSchoolName(school_id: string) {
  try {
    const url = urlbase().concat("school?school_id=").concat(school_id);
    const schoolResponse = await axios.get(url, { headers: headers() });
    return {
      code: schoolResponse.status,
      message: schoolResponse.statusText,
      data: schoolResponse.data,
    };
  } catch (e) {
    return { code: e.status, message: e.response, data: e.response };
  }
}

export async function updateProfile(
  name: string,
  surname: string,
  grade: string,
  contactNumber: string,
  gender: string,
  school: number,
  token: string
) {
  try {
    const profileDetails = {
      name: name,
      surname: surname,
      grade: grade,
      contactnr: contactNumber,
      gender: gender,
      school: school,
      token: token,
    };

    const url = urlbase().concat("student/update");

    const updateProfileResponse = await axios.post(
      url,
      JSON.stringify(profileDetails),
      { headers: headers() }
    );

    return {
      code: 200,
      message: updateProfileResponse.status,
      data: updateProfileResponse.data,
    };
  } catch (e) {
    return { code: e.status, message: e.response, data: e.response };
  }
}

export async function updatePassword(
  id: number,
  token: string,
  password: string
) {
  try {
    const passwordDetails = {
      id: id,
      token: token,
      password: password,
    };

    const url = urlbase().concat("student/updatePassword/v2");

    const updatePasswordResponse = await axios.post(
      url,
      JSON.stringify(passwordDetails),
      { headers: headers() }
    );

    return {
      code: 200,
      message: updatePasswordResponse.status,
      data: updatePasswordResponse.data,
    };
  } catch (e) {
    return { code: e.status, message: e.response, data: e.response };
  }
}

export async function registerUser(
  first_name: string,
  last_name: string,
  dob: Date,
  school_id: number,
  grade: string,
  gender: string,
  contact: string,
  popi: boolean
) {
  try {
    const user = {
      first_name: first_name,
      last_name: last_name,
      school_id: school_id,
      dob: dob,
      contact: contact,
      gender: gender,
      grade: grade,
      popi: popi,
    };

    const url = urlbase().concat("student/register/v3");

    const registerResponse = await axios.post(url, JSON.stringify(user), {
      headers: headers(),
    });

    return {
      code: 200,
      message: registerResponse.status,
      data: registerResponse.data,
    };
  } catch (e) {
    return { code: e.status, message: e.response, data: e.response };
  }
}

export async function updateForgotPasswordSMS(
  username: string,
  contact: string
) {
  try {
    const url = urlbase().concat("student/updatePasswordSMS");
    const body = {
      username: username,
      contact: contact,
    };

    const smsResponse = await axios.post(url, JSON.stringify(body), {
      headers: headers(),
    });
    return { code: 200, message: smsResponse.status, data: smsResponse.data };
  } catch (e) {
    return { code: e.status, message: e.response, data: e.response };
  }
}

export async function changePassword(
  id: number,
  token: string,
  password: string
) {
  try {
    const url = urlbase().concat("student/updatePassword/v2");
    const body = {
      id: id,
      token: token,
      password: password,
    };

    const smsResponse = await axios.post(url, JSON.stringify(body), {
      headers: headers(),
    });
    return { code: 200, message: smsResponse.status, data: smsResponse.data };
  } catch (e) {
    return { code: e.status, message: e.response, data: e.response };
  }
}

export async function confirmRegistration(
  id: number,
  token: string,
  username: string,
  password: string
) {
  try {
    const url = urlbase().concat("student/confirmRegistration");
    const body = {
      id: id,
      token: token,
      username: username,
      password: password,
    };

    const smsResponse = await axios.post(url, JSON.stringify(body), {
      headers: headers(),
    });
    return { code: 200, message: smsResponse.status, data: smsResponse.data };
  } catch (e) {
    return { code: e.status, message: e.response, data: e.response };
  }
}

export async function checkTokenExpired(token: string) {
  try {
    const url = urlbase().concat("check-token-expired");
    const body = {
      token: token,
    };

    const response = await axios.post(url, JSON.stringify(body), {
      headers: headers(),
    });
    return { 
      code: response.status, 
      message: response.statusText, 
      data: response.data 
    };
  } catch (e) {
    return { code: e.status, message: e.response, data: e.response };
  }
}

export async function contactUs(
  name: string,
  surname: string,
  contact: string,
  email: string,
  query: string,
  message: string,
  newMobileNumber?: string // Make newMobileNumber optional
) {
  try {
    const url = urlbase().concat("contact");
    const body: any = {
      name: name,
      surname: surname,
      contact_nr: contact,
      email_address: email,
      query_type: query,
      additional_message: message,
    };

    // Conditionally include newMobileNumber in the request body
    if (query === "New / Forgot Cellphone Number" && newMobileNumber) {
      body.new_contact_nr = newMobileNumber;
    }

    const contactUsResponse = await axios.post(url, JSON.stringify(body), {
      headers: headers(),
    });

    return {
      code: 200,
      message: contactUsResponse.status,
      data: contactUsResponse.data,
    };
  } catch (e) {
    return { code: e.status, message: e.response, data: e.response };
  }
}
